import { render, staticRenderFns } from "./WorkReportTable.vue?vue&type=template&id=a1ca2a52&scoped=true&"
import script from "./WorkReportTable.vue?vue&type=script&lang=js&"
export * from "./WorkReportTable.vue?vue&type=script&lang=js&"
import style0 from "./WorkReportTable.vue?vue&type=style&index=0&id=a1ca2a52&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ca2a52",
  null
  
)

export default component.exports